module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/cosenza.2485bd5b79ea5a0e7a33b571df7a7904.jpg";